/**
 * Submission-readiness client (DEV-3782, Skynet.Loans behind the loans gateway).
 * GET /api/loanapplications/{applicationId}/submission-readiness returns the
 * file's underwriting-submission requirement check for a TPO broker.
 *
 * Response shape:
 *   { ready, missingItems: [{ itemId, label, categoryLabel }],
 *     evaluatedAgainst, asOf }
 *
 * A 403 (broker-auth gap) or empty response must degrade to the neutral
 * "no requirements / unknown" state — never trigger the global forbidden
 * page-reload loop.
 */
export class SubmissionReadinessApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getSubmissionReadiness({ applicationId, config = {} }) {
    return this.#http.get(`/api/loanapplications/${applicationId}/submission-readiness`, config);
  }
}
